import script from "./Location.vue?vue&type=script&setup=true&lang=js"
export * from "./Location.vue?vue&type=script&setup=true&lang=js"

import "./Location.vue?vue&type=style&index=0&id=66581a14&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66581a14"]])

export default __exports__